<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                  <v-btn :to="{name: 'services'}" color="blue" class="mb-2" block>Lista usług</v-btn>
                  <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="filters.dateFrom"
                                    label="Od"
                                    prepend-icon="mdi-calendar-blank"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.dateFrom"
                            :first-day-of-week="1"
                            @input="menu1 = false"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div>
                    <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="filters.dateTo"
                                    label="Do"
                                    prepend-icon="mdi-calendar-blank"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.dateTo"
                            :first-day-of-week="1"
                            @input="menu2 = false"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div>
                    <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                    </v-menu>
                </div>
                <div>
                    <v-text-field v-model="filters.phone" label="Telefon" prepend-icon="mdi-phone"></v-text-field>
                </div>
              <div>
                <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-select
                        :items="supervisors"
                        v-model="filters.supervisor"
                        label="Opiekun"
                        item-value="id"
                        solo
                        v-bind="attrs"
                        v-on="on"
                        class="wastemaster-input-elevation"
                    >
                      <template v-slot:selection="data">
                        {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                      </template>
                    </v-select>
                  </template>
                </v-menu>
              </div>
                <div>
                    <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                    </v-menu>
                </div>
                <div>
                    <v-chip-group v-model="filters.status" column active-class="primary--text" multiple>
                        <v-chip v-for="(key, status) in statuses" :key="status" :value="status">
                            {{ getStatusText(status) }} ({{ getStat(status) }})
                        </v-chip>
                    </v-chip-group>
                </div>
                <v-btn @click="getOrders();" color="primary" block>Filtruj</v-btn>
            </v-col>
            <v-col cols="10">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="orders"
                        :options.sync="options"
                        :server-items-length="totalOrders"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                        @click:row="(order) => $router.push({name: 'order-details', params: { id: order.id }}).catch(()=>{})"
                >
                    <template v-slot:item.id="{ item }">
                        {{ item.uniqueId }} ({{ item.id }})
                    </template>
                    <template v-slot:item.supervisor="{ item }">
                        <span v-if="item.supervisor" :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                          {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                        </span>
                        <span v-else>
                          -
                        </span>
                    </template>

                    <template v-slot:item.status="{ item }">
                        {{ getStatusText(item.status) }}
                    </template>
                    <template v-slot:item.user="{ item }">
                      <router-link :to="{name: 'user-details', params: { id: item.user.id }}">
                        {{ item.user.email }}
                      </router-link>
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                        {{ localDateTime(item.createdAtDto) }}
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
    import {OrderStatus, getStatusText} from '@/enums/OrderStatus';
    import moment from 'moment';
    import permissions from '@/mixins/permissions';
    import debounce from "debounce";

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                statuses: OrderStatus,
                modal: false,
                menu1: false,
                menu2: false,
                menu3: false,
                menu4: false,
                filters: {
                    dateFrom: this.getDateFrom().format('YYYY-MM-DD'),
                    dateTo: moment().format('YYYY-MM-DD'),
                    phone: null,
                    supervisor: null,
                    status: null,
                },
                totalOrders: 0,
                orders: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'Opiekun', value: 'supervisor', sortable: false },
                    { text: 'Kategoria', value: 'service.type.category', sortable: false },
                    { text: 'Usługa', value: 'service.type.name', sortable: false },
                    { text: 'Użytkownik', sortable: false, value: 'user' },
                    { text: 'Telefon', sortable: false, value: 'additionalDataRaw.phone' },
                    { text: 'Status', value: 'status', sortable: false, },
                    { text: 'Utworzono', value: 'createdAt', sortable: false },
                ],
                reactOnFilterChange: true,
                supervisorFilter: null,
                stats: [],
              supervisors: [],
            }
        },
        watch: {
            options: {
                handler () {
                    this.getOrders();
                },
                deep: true,
            },
            filters: {
                handler() {
                    if (!this.reactOnFilterChange) {
                        return;
                    }

                    setDatatableFilters.call(this);
                },
                deep: true
            },

          supervisorFilter() {
            this.getOrdersFilteredBySupervisor();
          },
        },
        methods: {
            getDateFrom() {
                if (this.isAdmin()) {
                    return moment().clone().subtract(3, 'months');
                }

                return moment().clone().subtract(2, 'weeks');
            },
            async getOrders() {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                if (this.filters.dateFrom) {
                    const dateFromString = String(this.filters.dateFrom).substr(0, 10);
                    this.reactOnFilterChange = false;

                    if (!moment(dateFromString).isValid()) {
                      this.filters.dateFrom = this.getDateFrom();
                    } else {
                      this.filters.dateFrom = dateFromString;
                    }

                    this.reactOnFilterChange = true;
                }

                let filters = this.filters

                if (filters.phone) {
                    filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
                }

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0,
                    ...this.filters
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (!params.status) {
                    delete params.status;
                }

                const response = await api.get('/api/orders', {params});
                this.loading = false;

                this.orders = response.data.items;
                this.totalOrders = response.data.total;
                this.reactOnFilterChange = false;
                this.filters.dateFrom = response.data.dateFrom;

                setDatatableOptions.call(this);

                setTimeout(() => {
                    this.reactOnFilterChange = true;
                }, 1000); // Delay the change a bit to avoid performing another query.
            },
            async getStats() {
                const response = await api.get('/api/orders/stats');
                for (const [key, value] of Object.entries(response.data)) {
                    this.stats[key] = value;
                }
            },
            getStatusText(status) {
                return getStatusText(status);
            },
            getStat(status) {
                return this.stats[status];
            },
          async getSupervisors() {
            this.loading = true;

            const response = await api.get('/api/users?role=ROLE_SUPERVISOR', {});
            this.loading = false;

            this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(response.data.items)
          },
        },
        created() {
            this.getSupervisors();
            getDatatableParams.call(this);
            for (const [key] of Object.entries(this.statuses)) {
                this.stats[key] = 0;
            }
            this.getStats();
          this.getOrdersFilteredBySupervisor = debounce(function () {
            this.getOrders();
          }, 500);
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> td {
      height: auto !important;
      padding: 0.5rem !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-chip {
        white-space: break-spaces !important;
        line-height: 14px;
        width: 100%;
        padding: 9px;
    }

    .v-chip .v-chip__content {
        max-width: 100%;
        height: auto;
        overflow: auto;
        min-height: 32px;
        white-space: pre-wrap;
    }
</style>